import { render, staticRenderFns } from "./CeurClaimProductRegistration.vue?vue&type=template&id=2ef8540c"
import script from "./CeurClaimProductRegistration.vue?vue&type=script&lang=js"
export * from "./CeurClaimProductRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports